import React from "react";
import dooralliance from "src/assets/images/door-alliance.jpeg"
import orange from "src/assets/images/orange.png";

const AllianceSection: React.FC = () => {
  return (
    <div className=" grid-background-image-top">
      <div className="flex items-center justify-center  mx-auto text-center p-6">
        <h1 className="text-[32px] sm:text-[40px] md:text-[48px] font-[400] leading-[1.2] mt-[3rem]">
          Une alliance{" "}
          <i className="app-title-italic text-[#20E87F] text-[48px]">
            stratégique
          </i>{" "}
          pour <br />
          relever les défis
        </h1>
      </div>
      <div className="flex flex-wrap justify-center gap-6 p-6">
        <div className="bg-[#021D35] text-white p-6 rounded-2xl shadow-lg max-w-[27rem] flex flex-row items-center">
          <div className="mr-[1.2rem]">
            <img
              src={dooralliance}
              alt="Cloudoor"
              className="w-[13rem] h-[5rem] rounded-[8px]"
            />
          </div>
          <div>
            <h3 className="text-[24px] sm:text-[28px] md:text-[32px] leading-[30px] sm:leading-[34px] md:leading-[38.4px] tracking-[-0.01em]">
              Cloudoor
            </h3>
            <p className="text-[#FFFFFFBF] text-[14px] sm:text-[16px] leading-[20px] sm:leading-[24px] tracking-[-0.02em] mt-2">
              Services modernes et simples d'utilisation: IA, DevOps, API
              Gateway, le déploiement de code et base données.
            </p>
          </div>
        </div>
        <div className="bg-[#021D35] text-white p-6 rounded-2xl shadow-lg max-w-[27rem] flex flex-row items-center">
          <div>
            <h3 className="text-[24px] sm:text-[28px] md:text-[32px] leading-[30px] sm:leading-[34px] md:leading-[38.4px] tracking-[-0.01em]">
              Groupement Orange Services S.A
            </h3>
            <p className="text-[#FFFFFFBF] text-[14px] sm:text-[16px] leading-[20px] sm:leading-[24px] tracking-[-0.02em] mt-2">
              Une infrastructure hautement disponible au niveau local (Sénégal
              et Côte d'Ivoire) et régional (UEMOA).
            </p>
          </div>
          <div className="ml-[1.2rem]">
            <img
              src={orange}
              alt="Orange"
              className="w-[13rem] h-[5rem] rounded-[8px]"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllianceSection;
